import { useEffect, useState } from 'react'
import { MarginOverviewRow } from '../../../types/MarginValuation'
import BackOfficeAPIClient from '../../../clients/BackofficeAPIClient'

const backofficeApiClient = new BackOfficeAPIClient()

export interface MarginValuationRawData {
    data: MarginOverviewRow[]
    loading: boolean
    refetch: () => Promise<void>
}

/**
 * Toutes les lignes (global + par site + par marque), pour calculer la valeur par défaut en mode
 * config multi-sites/multi-marques. `refetch` doit être appelé après chaque enregistrement (cf.
 * MarginValuation.tsx) : sans ça, si l'utilisateur enregistre puis change de sélection sans
 * recharger la page, la fusion/le repli exact-combo utiliserait des données périmées.
 */
export function useMarginValuationRawData(): MarginValuationRawData {
    const [ data, setData ] = useState<MarginOverviewRow[]>([])
    const [ loading, setLoading ] = useState(true)

    const fetchData = async () => {
        setLoading(true)
        try {
            setData(await backofficeApiClient.get<MarginOverviewRow[]>('/valuation-settings/overview'))
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    return { data, loading, refetch: fetchData }
}
